// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".static {\n  position: relative;\n  border: 1px solid #ddd;\n  box-shadow: 0px 1px 3px 0px rgba(220, 220, 220, 1);\n}\n", ""]);
// Exports
module.exports = exports;
